module.exports = __webpack_public_path__ + "static/img/policy_kunming.1ff51355.png";